<template>
  <el-dialog
    title="添加系统管理员"
    :visible.sync="outerVisible"
    width="500px"
    @close="closeFun"
    style="text-align:left;"
  >
    <el-form ref="forms" :model="form" :rules="rules" label-width="100px" label-position="left">
      <el-form-item label="管理员手机号" prop="name">
        <el-col>
          <el-input
            width="270px"
            height="32px"
            v-model="form.name"
            oninput="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入要添加的管理员手机号"
            @blur="verdict_phone"
          ></el-input>
          <div class="error" id="_error_"></div>
        </el-col>
      </el-form-item>
      <el-form-item label="角色" prop="region">
        <el-col>
          <el-select
            @blur="verdict_select"
            width="270px"
            v-model="roleId"
            placeholder="请选择"
            @change="selectId"
          >
            <el-option
              v-for="item in form.region"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            ></el-option>
          </el-select>
          <div v-if="error" class="error">请选择角色</div>
          <div v-else class="error"></div>
        </el-col>
      </el-form-item>
      <el-form-item label="IP白名单" prop="resource">
        <el-radio-group v-model="form.resource">
          <el-radio label="不启用"></el-radio>
          <el-radio label="启用"></el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-dialog
      class="confirm"
      width="440px"
      title="管理员信息确认"
      :visible.sync="innerVisible"
      append-to-body
    >
      <div>
        <b>管理员手机号</b>
        {{form.name}}
      </div>
      <div>
        <b>姓名</b>
        {{userName}}
      </div>
      <div>
        <b>角色</b>
        {{showValue}}
      </div>
      <div class="ip_sure">
        <b>IP白名单</b>
        <ul v-if="iplist.length!=0">
          <li v-for="item in iplist" :key="item">{{item}}</li>
        </ul>
        <span v-else>无</span>
      </div>
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="tijiao()">确认添加</el-button>
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <el-button class="close_btu" @click="closeFun">取 消</el-button>
      <el-button class="true_tbu" type="primary" @click="commitAdmin('forms')">添加</el-button>
    </div>
    <div class="iplist_box" v-show="form.resource == '启用'">
      <div class="iplist_titile">
        <el-button icon="el-icon-plus" size="mini" @click="addIp" circle></el-button>
        <span>IP白名单列表</span>
      </div>
      <div class="iplist" id="iplist">
        <ul class="iplist_list" v-for="(item) in iplist_arr" :key="item">
          <li class="ipNum_test list_quan ipNum ipNum1" @click="edit($event)">{{item.num1}}</li>
          <li class="ip_dian ipNum">.</li>
          <li class="ipNum_test list_quan ipNum ipNum2" @click="edit($event)">{{item.num2}}</li>
          <li class="ip_dian ipNum">.</li>
          <li class="ipNum_test list_quan ipNum ipNum2" @click="edit($event)">{{item.num3}}</li>
          <li class="ip_dian ipNum">.</li>
          <li class="ipNum_test list_quan ipNum ipNum3" @click="edit($event)">{{item.num4}}</li>
          <li class="list_quan1">
            <el-button
              style="padding:4px;width:22px"
              icon="el-icon-minus"
              size="mini"
              @click="removeIp($event)"
              circle
            ></el-button>
          </li>
        </ul>
      </div>
      <p v-if="ip_show" class="warning">您输入的IP格式不正确,请重新输入</p>
    </div>
  </el-dialog>
</template>

<script>
import { getRole, addAdmin, getUser, getMobile } from "../../../api/index";
import { validateTel } from "../../../utils/validate";
import { showError, addErrorClass } from "../../../utils/common";
export default {
  data() {
    return {
      is: false,
      error: false,
      num1: "",
      num2: "",
      num3: "",
      num4: "",
      form: {
        resource: "不启用",
        name: "",
        region: []
      },
      showValue:'',//显示出来的选择了的角色
      iplist_arr: [],
      iplist: [],
      limit: "1",
      roleId: "",
      roleName:'',
      roleValue: "",
      outerVisible: false,
      innerVisible: false,
      ip_show: false,
      ip_shows: false,
      userName: "",
      titleEditing: false,
      loginData: {},
      commitButtom: true
    };
  },
  mounted() {},
  methods: {
    init() {
      this.outerVisible = true;
      // 获取角色列表
      getRole()
        .then(res => {
          this.form.region = res.data;
          console.log(this.form.region,'9900')
        })
        .catch(error => {});
    },
    //关闭dialog清空输入内容和错误提示
    closeFun() {
      this.outerVisible = false;
      this.error = false;
      this.roleValue = null;
      this.ip_show = false;
      this.roleId = null;
      this.userName = "";
      this.form = {
        resource: "不启用",
        name: "",
        region: []
      };
      this.iplist_arr = [];
      showError("");
      addErrorClass("_password_");
      addErrorClass("phone_num", !0);
    },
    //验证手机号
    verdict_phone() {
      const mobile = this.form.name;
      console.log(mobile);
      if (!validateTel(mobile)) {
        showError("手机号码格式不正确");
        addErrorClass("_password_");
        addErrorClass("phone_num", !0);
      } else {
        let data = mobile;
        getMobile(data)
          .then(res => {
            this.userName = res.data;
            showError("");
            addErrorClass("_password_");
            addErrorClass("phone_num", !0);
            this.commitButtom = true;
          })
          .catch(error => {
            showError("该担当用户不存在");
            addErrorClass("_password_");
            addErrorClass("phone_num", !0);
            this.commitButtom = false;
          });
      }
    },
    //验证是否选择
    verdict_select() {
      const roleValue = this.roleValue;
      if (roleValue == "") {
        this.error = true;
      } else {
        this.error = false;
      }
    },
    //选择角色
    selectId(value) {
     var obj =  this.form.region.filter(function(item){
        return item.roleId == value
      })
      this.showValue = obj[0].roleName
      this.roleValue = value;
    },
    //点击添加要调显示名字的接口
    commitAdmin(a) {
      //验证form表单
      const mobiles = this.form.name;
      const roleValue = this.roleValue;
    
      if (!validateTel(mobiles)) {
        showError("手机号码格式不正确");
        addErrorClass("_password_");
        addErrorClass("form.name", !0);
      } else if (roleValue == "") {
        this.error = true;
      } else if (!this.commitButtom) {
      } else {
        this.error = false;
        let data = {
          mobile: this.form.name
        };
        if (this.form.resource == "启用") {
          this.limit = 1;
          var iplist_list = document.getElementsByClassName("iplist_list");
          if (iplist_list.length >= 1) {
            this.iplist = [];
            for (let index = 0; index < iplist_list.length; index++) {
              let ipNum = iplist_list[index].getElementsByClassName("ipNum");
              let str = "";
              for (let i = 0; i < ipNum.length; i++) {
                str = str + ipNum[i].innerHTML;
              }
              this.iplist.push(str);
            }
            this.testContent();
            this.iplist_str();
            if (!this.ip_show) {
              this.innerVisible = true;
            }
          } else if (iplist_list.length == 0) {
            this.ip_show = false;
            if (!this.ip_show) {
              this.innerVisible = true;
            }
          }
        } else {
          this.limit = 0;
          this.iplist = [];
          this.ip_shows = false;
          this.ip_show = false;
          if (!this.ip_show) {
            this.innerVisible = true;
          }
        }
      }
    },
    handle() {
      console.log(this.value,'8888');
    },
    // 检测内容
    testContent() {
      var a = [];
      var all_ipNum = document.getElementsByClassName("ipNum_test");
      for (let k = 0; k < all_ipNum.length; k++) {
        var reg = /^[1-9]\d*$|^0$/;
        if (reg.test(all_ipNum[k].innerHTML) == true) {
          a.push("true");
          all_ipNum[k].style.color = "#323232";
        } else {
          a.push("false");
          all_ipNum[k].style.color = "red";
        }
      }
      if (a.indexOf("false") == -1) {
        this.ip_show = false;
        // this.innerVisible = true;
      } else {
        this.ip_show = true;
      }
    },
    tijiao() {
      this.loginData = JSON.parse(localStorage.getItem("loginData"));
      let data = {
        ipList: this.iplist,
        mobile: this.form.name,
        limit: this.limit,
        roleId: this.roleId,
        userId: this.loginData.userId
      };
      // 添加管理员
      addAdmin(data)
        .then(res => {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.$emit("getAdminFun");
          this.outerVisible = false;
          this.innerVisible = false;
        })
        .catch(error => {
          this.$message.error(error.msg);
          this.innerVisible = false;
        });
    },
    // 转换ip格式
    iplist_str() {
      for (let i = 0; i < this.iplist.length; i++) {
        // this.iplist_arr.push(this.iplist[i].split("."));
        var arr = this.iplist[i].split(".");
        let obj = {
          num1: arr[0],
          num2: arr[1],
          num3: arr[2],
          num4: arr[3]
        };
      }
    },
    // 点击删除该IP地址
    removeIp(e) {
      e.currentTarget.parentNode.parentNode.remove();
    },
    // 添加一条IP地址
    addIp() {
      this.iplist_arr.push({
        num1: "",
        num2: "",
        num3: "",
        num4: ""
      });
    },
    // 点击修改ip地址
    edit(element) {
      if (this.titleEditing) {
        return;
      }
      this.titleEditing = true;
      let old = element.target.innerHTML;
      element.target.innerHTML = "";
      var newObj = document.createElement("input");
      newObj.value = old;
      element.target.appendChild(newObj);
      newObj.style.width = "100%";
      newObj.style.height = "100%";
      newObj.style.padding = "0";
      newObj.style.margin = "0";
      newObj.style.border = "none";
      newObj.style.outline = "none";
      newObj.focus();
      var that = this;
      newObj.onblur = function() {
        element.target.style.color = "#323232";
        element.target.innerHTML = this.value ? this.value : old;
        that.titleEditing = false;
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  height: 20px;
  line-height: 20px;
  color: red;
}
.true_tbu {
  width: 80px;
}
.close_btu {
  color: #999999;
  background-color: #e5e5e5;
  width: 80px;
}
/deep/.el-dialog {
  .el-dialog__header {
    padding: 16px;
    border-bottom: 1px solid #f4f4f4;
    .el-dialog__title {
      font-size: 14px;
      font-weight: 400;
      color: #323232;
    }
  }
  .el-dialog__body {
    padding: 20px 66px;
  }
}
/deep/.el-form {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__label {
    text-align: right;
    font-size: 14px;
    color: #323232;
    font-weight: 400;
  }
  .el-input__inner {
    height: 38px;
    width: 270px;
  }
}
ul {
  list-style: none;
  padding: 0;
  width: 340px;
  margin: 0 auto;
}
.iplist_box {
  position: relative;
  text-align: center;
  width: 100%;
  padding-bottom: 20px;
  /* height: 100px; */
  border: 1px solid #e2e2e2;
  .iplist_titile {
    height: 30px;
    width: 100%;
    padding-top: 20px;
    color: #aaaaaa;
    /deep/.el-icon-mini {
      padding: 4px;
      margin-top: 10px;
      margin-right: 5px;
    }
  }
  .iplist {
    display: flex;
    flex-direction: column;
    .iplist_list {
      list-style: none;
      flex: 1;
      display: flex;
      flex-direction: row;
      margin-top: 10px;
      padding-left: 20px;
      padding-right: 20px;
      li {
        height: 38px;
        line-height: 38px;
        list-style: none;
        overflow: hidden;
        .inp {
          width: 100%;
          height: 100%;
          padding: 0;
          margin: 0;
          border: none;
          outline: none;
        }
      }
      .list_quan {
        flex: 1;
      }
      .list_quan1 {
        width: 40px;
      }
      .ipNum1 {
        border: 1px solid #e2e2e2;
        border-right: 0px solid #e2e2e2;
      }
      .ipNum2 {
        border: 1px solid #e2e2e2;
        border-left: 0px solid #e2e2e2;
        border-right: 0px solid #e2e2e2;
      }
      .ipNum3 {
        border: 1px solid #e2e2e2;
        border-left: 0px solid #e2e2e2;
      }
      .ip_dian {
        border-top: 1px solid #e2e2e2;
        border-bottom: 1px solid #e2e2e2;
        line-height: 30px;
        display: flex;
        height: 30px;
        text-align: center;
      }
    }
  }
  .warning {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
    color: red;
    margin: 0;
  }
}
.confirm {
  /deep/.el-button--default {
    margin-left: 40px;
  }
  div {
    margin: 10px;
    b {
      width: 100px;
      display: inline-block;
      text-align: right;
      margin-right: 10px;
    }
  }
  .ip_sure {
    margin-bottom: 20px;
    ul {
      padding-left: 115px;
      width: 200px;
      margin-top: -19px;
    }
  }
}
</style>
